import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';

const exportProjectExcel = (allocationData, exportFileName) => {
  const workbook = XLSX.utils.book_new();

  const cellStyle = {
    // font: {
    //   name: 'Arial',
    //   sz: 14,
    //   bold: true,
    //   color: { rgb: 'FF0000' } // 红色字体
    // },
    // fill: {
    //   fgColor: { rgb: 'FFFF00' } // 黄色背景
    // },
    // border: {
    //   top: { style: 'thin', color: { rgb: '000000' } },
    //   bottom: { style: 'thin', color: { rgb: '000000' } },
    //   left: { style: 'thin', color: { rgb: '000000' } },
    //   right: { style: 'thin', color: { rgb: '000000' } }
    // },
    alignment: {
      horizontal: 'center',
      vertical: 'center',
    },
  };
   // 处理每个 sheet 的数据并设置样式
  function createWorksheet(data, sheetName, dataCount) {
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    // 获取工作表的范围
    const range = XLSX.utils.decode_range(worksheet['!ref']);

    // 遍历每个单元格并设置居中样式
    for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
            const cell = worksheet[cellAddress];
            if (cell) {
                cell.s = cellStyle;
            }
        }
    }

    // 合并单元格，让项目名称正常展示
    const mergeList = [];
    for (let i = 0; i < allocationData.retainCount.project; i++) {
      const row = dataCount + i;
      mergeList.push({ s: { r: row, c: 3 }, e: { r: row, c: 9 } });
    }
    worksheet['!merges'] = mergeList;

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  }

  createWorksheet(allocationData.department, "部门统计表", allocationData.retainCount.department);
  createWorksheet(allocationData.projectTime, "分配项目工时", allocationData.retainCount.projectTime);
  createWorksheet(allocationData.projectManualCost, "分配项目人工成本", allocationData.retainCount.projectManualCost);

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, `${exportFileName}.xlsx`);
}

export default exportProjectExcel;